// Downloadable Claude Skill packages, grounded directly in this deck's own
// content (Module 6: Connectors, skills & plugins). Each zip unpacks to a
// folder named after the skill, ready to drop into a Claude Skills library.
export const claudeCourseSkills = [
  {
    slug: 'site-report',
    name: 'Site Report',
    description: 'Formats any site inspection write-up with the four standard headings: Site, Findings, Actions, Sign-off, in UK English, with gaps flagged instead of invented.',
    zip: '/skills/site-report.zip',
    cover: '/skills/cover-site-report.svg',
    courseId: 'civils2000-claude-professionals',
    courseTitle: 'Claude for Professionals',
  },
  {
    slug: 'prompt-scaffold',
    name: 'Prompt Scaffold',
    description: 'Applies the five-habits scaffold from Module 1 to any drafting request: audience, source material, format, tone, and flagging uncertainty.',
    zip: '/skills/prompt-scaffold.zip',
    cover: '/skills/cover-prompt-scaffold.svg',
    courseId: 'civils2000-claude-professionals',
    courseTitle: 'Claude for Professionals',
  },
];

// General-purpose skills not tied to a single course.
export const generalSkills = [
  {
    slug: 'llm-council',
    name: 'LLM Council',
    description: 'Runs any question, idea, or decision through 5 independent AI advisors (Contrarian, First Principles, Expansionist, Outsider, Executor) who peer-review each other anonymously, then a chairman synthesizes a single, direct verdict.',
    zip: '/skills/llm-council.zip',
    cover: '/skills/cover-llm-council.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
    featured: true,
    featuredReason: 'A single AI answer is one opinion with no way to check its blind spots. The Council forces 5 opposing lenses to argue the same question, catches what any one of them would have missed, and ends in one clear recommendation instead of "it depends", exactly when a decision is expensive enough that being wrong actually costs you.',
  },
  {
    slug: 'humanizer',
    name: 'Humanizer',
    description: 'Edits any text to remove the tells of AI-generated writing (em dashes, filler phrases, inflated language, rule-of-three padding) while keeping every fact from the source intact.',
    zip: '/skills/humanizer.zip',
    cover: '/skills/cover-humanizer.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'notebooklm',
    name: 'NotebookLM Research Assistant',
    description: 'Queries your Google NotebookLM notebooks from Claude Code for source-grounded, citation-backed answers, so responses come only from your uploaded documents.',
    zip: '/skills/notebooklm.zip',
    cover: '/skills/cover-notebooklm.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'caveman',
    name: 'Caveman Mode',
    description: 'Ultra-compressed communication mode that cuts output tokens while keeping full technical accuracy, with lite, full and ultra intensity levels.',
    zip: '/skills/caveman.zip',
    cover: '/skills/cover-caveman.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'caveman-compress',
    name: 'Caveman Compress',
    description: 'Compresses natural language memory files (CLAUDE.md, todos, preferences) into terser prose to save input tokens, while preserving every code block, URL, and command exactly.',
    zip: '/skills/caveman-compress.zip',
    cover: '/skills/cover-caveman-compress.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'caveman-help',
    name: 'Caveman Help',
    description: 'A one-shot quick-reference card listing every caveman mode, skill, and command, without changing or persisting any mode itself.',
    zip: '/skills/caveman-help.zip',
    cover: '/skills/cover-caveman-help.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'caveman-stats',
    name: 'Caveman Stats',
    description: 'Shows real token usage and estimated savings for the current session, read directly from the Claude Code session log rather than estimated by the model.',
    zip: '/skills/caveman-stats.zip',
    cover: '/skills/cover-caveman-stats.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'cavecrew',
    name: 'Cavecrew',
    description: 'A decision guide for delegating to caveman-style subagents (investigator, builder, reviewer) that return compressed results, so main context lasts longer across long sessions.',
    zip: '/skills/cavecrew.zip',
    cover: '/skills/cover-cavecrew.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'seo-geo-aeo',
    name: 'SEO / GEO / AEO Audit',
    description: 'Audits any URL for traditional SEO, Generative Engine Optimization (AI search readiness), and Answer Engine Optimization, then produces a downloadable Word and PDF report.',
    zip: '/skills/seo-geo-aeo.zip',
    cover: '/skills/cover-seo-geo-aeo.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
  {
    slug: 'frontend-design',
    name: 'Frontend Design',
    description: 'Guidance for distinctive, intentional visual design when building or reshaping a UI, covering palette, typography, layout, and motion choices that avoid templated defaults.',
    zip: '/skills/frontend-design.zip',
    cover: '/skills/cover-frontend-design.svg',
    courseId: 'general',
    courseTitle: 'General Resources',
  },
];

// Every downloadable skill across all courses, surfaced to candidates in the
// Library tab. Add new course skill arrays here as more courses ship them.
export const skillLibrary = [...claudeCourseSkills, ...generalSkills];
